import login from "./login";
import operations from "./operations";
import consult from "./consult";
import expert from "./expert";
import user from "./user";
import course from "./course";
import meeting from "./meeting";
import doctor from "./doctor";
import sentive from "./sensitive";
import comment from "./comment";
import upload from "./upload";
import permission from "./permission";
import subject from "./subject";
import questionnaire from "./questionnaire";
import caseManage from "./case";
import templates from "./templates";
import vrManage from "./vrmanage";

import projects from "./projects";
import repreSentative from "./representative";
import dataManage from "./dataManage";
import projectManage from "./projectManage";
import patientManage from "./patient";
import exportFiles from "./exportFiles";
import document from "./document";
import hospital from "./hospital";
import training from "./training";
import patientList from "./patientList";
import scanCodeRecord from "./scanCodeRecord";
import targetManage from "./targetManage";
import examManage from "./examManage";
import channel from "./channel";
export default {
  ...login,
  ...operations,
  ...consult,
  ...expert,
  ...user,
  ...course,
  ...meeting,
  ...doctor,
  ...sentive,
  ...comment,
  ...upload,
  ...permission,
  ...subject,
  ...questionnaire,
  ...caseManage,
  ...templates,
  ...vrManage,
  ...projects,
  ...repreSentative,
  ...dataManage,
  ...projectManage,
  ...patientManage,
  ...exportFiles,
  ...document,
  ...hospital,
  ...training,
  ...patientList,
  ...scanCodeRecord,
  ...targetManage,
  ...examManage,
  ...channel,
};
